import React from 'react';
import ReactDOM from 'react-dom/client';
import Langague from './Langague';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Langague />
  </React.StrictMode>
);